import { render, staticRenderFns } from "./VetAccount.vue?vue&type=template&id=1bd919f2&scoped=true&"
import script from "./VetAccount.vue?vue&type=script&lang=js&"
export * from "./VetAccount.vue?vue&type=script&lang=js&"
import style0 from "./VetAccount.vue?vue&type=style&index=0&id=1bd919f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd919f2",
  null
  
)

export default component.exports